import {
  ADD_DICT_REQUEST,
  ADD_DICT_SUCCESS,
  ADD_DICT_FAILURE,
  DELETE_DICT_REQUEST,
  DELETE_DICT_SUCCESS,
  DELETE_DICT_FAILURE,
  ADD_DICT_ATTRS_REQUEST,
  ADD_DICT_ATTRS_SUCCESS,
  ADD_DICT_ATTRS_FAILURE,
  ADD_DICT_VALS_REQUEST,
  ADD_DICT_VALS_SUCCESS,
  ADD_DICT_VALS_FAILURE,
  GET_DICT_VALS_REQUEST,
  GET_DICT_VALS_SUCCESS,
  GET_DICT_VALS_FAILURE,
  GET_DICT_ATTRS_REQUEST,
  GET_DICT_ATTRS_SUCCESS,
  GET_DICT_ATTRS_FAILURE,
} from '../constants';

import fetch from '../core/fetch';

export function deleteDict(prefix, dictionary) {
  return function (dispatch) {
    dispatch({ type: DELETE_DICT_REQUEST });
    return fetch(process.env.API_URL + '/district/' + prefix + '/dictionary?layerName=' + dictionary.layer + '&dictName=' + dictionary.name, {
      method: 'DELETE',
    })
    .then(async (response) => {
      if (response.status === 200) {
        return response.json();
      } else {
        dispatch({ type: DELETE_DICT_FAILURE });
        throw { error: 'Błąd przy usuwaniu słownika urzędu', status: response.status, text: await response.text() };
      }
    })
    .then((response) => {
      dispatch({ type: DELETE_DICT_SUCCESS });
      return response;
    })
    .catch(error => {
      console.info(error);
      throw error;
    });
  };
}

export function addDictAttrs(prefix, dictionary, layerName) {
  return function (dispatch) {
    dispatch({ type: ADD_DICT_ATTRS_REQUEST });
    return fetch(process.env.API_URL + '/district/' + prefix + '/dictionary/add_attributes?layerName=' + layerName + '&dictName=' + dictionary.name, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ attrs: dictionary.data }),
    })
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      } else {
        dispatch({ type: ADD_DICT_ATTRS_FAILURE });
        throw response;
      }
    })
    .then((response) => {
      dispatch({ type: ADD_DICT_ATTRS_SUCCESS });
      return response;
    })
    .catch(error => {
      console.info(error);
      throw error;
    });
  };
}

export function addDictVals(prefix, dictionary, layerName) {
  return function (dispatch) {
    const data = { attrs: dictionary.data };
    dispatch({ type: ADD_DICT_VALS_REQUEST });
    return fetch(process.env.API_URL + '/district/' + prefix + '/dictionary/add_vals?layerName=' + layerName + '&dictName=' + dictionary.name, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      } else {
        dispatch({ type: ADD_DICT_VALS_FAILURE });
        throw response;
      }
    })
    .then((response) => {
      dispatch({ type: ADD_DICT_VALS_SUCCESS });
      return response;
    })
    .catch(error => {
      console.info(error);
      throw error;
    });
  };
}

export function addDict(prefix, dictionary, layerName) {
  return function (dispatch) {
    dispatch({ type: ADD_DICT_REQUEST });
    return fetch(process.env.API_URL + '/district/' + prefix + '/dictionary?layerName=' + layerName + '&type=' + dictionary.type + '&dictName=' + dictionary.name, {
      method: 'POST',
    })
    .then(async (response) => {
      if (response.status === 200) {
        return response.json();
      } else {
        dispatch({ type: ADD_DICT_FAILURE });
        throw { error: 'Błąd przy dodawaniu słownika urzędu', status: response.status, text: await response.text() };
      }
    })
    .then((response) => {
      dispatch({ type: ADD_DICT_SUCCESS });
      return response;
    })
    .catch(error => {
      console.info(error);
      throw error;
    });
  };
}



// WEBPACK FOOTER //
// src/actions/dictionaries.js